export default __webpack_public_path__ + "static/layer5-hacktoberfest11-badge-large-d5a31599e714c8c1fd589409dc11b432.png";